module.exports = __webpack_public_path__ + "img/trash.714c5fbc.svg";